// Copyright (c) 2017 Deere & Company

export const addRemoveModalClass = isVisible =>
    isVisible ?
        document.body.classList.add('warranty-modal-is-open') :
        document.body.classList.remove('warranty-modal-is-open');



// WEBPACK FOOTER //
// ./src/shared/services/add-remove-modal-class.js